<template>
	<div id="login" class="pt-5 d-flex flex-column">
		<div class="flex-grow-1">
			<div class="d-flex mt-2 mt-sm-5 login-container card shadow-sm flex-column align-items-stretch">
				<div class="d-flex flex-row flex-fill align-items-stretch">
					<div class="first-access flex-fill">
						<div class="pt-2 pb-2 p-4">
							<router-view/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footer>
			<div class="container p-2 d-flex flex-row align-items-center">
				<div class="d-flex flex-grow-1 flex-row align-items-center">
					<img src="@/assets/images/logo-image2doc-wire-white.png" style="margin-right:12px" height="32" >
					<span class="d-none d-sm-flex">&copy; {{ moment(new Date()).format('YYYY') }} - {{ $t("DevelopedByPRORADIS") }}</span>
				</div>

				<div class="d-flex flex-row align-items-center">
					<a href="http://www.proradis.com.br" target="_blank"><img height="20" src="@/assets/images/logo-proradis-negativo.png"></a>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
	export default {
		name: "loginPage"
	}
</script>

<style lang="scss">
	@import '../../assets/_vars';

	footer {
		background:#0a2644;
		color:#f1f1f1;

		@media screen and (max-width: $mobile) {
			img {
				height:32px;
			}

			font-size:13px;
		}
	}

	#login {
		background: #ffffff; /* Old browsers */
		background: -moz-linear-gradient(-45deg, #ffffff 0%, #e0e0e0 100%); /* FF3.6-15 */
		background: -webkit-linear-gradient(-45deg, #ffffff 0%,#e0e0e0 100%); /* Chrome10-25,Safari5.1-6 */
		background: linear-gradient(135deg, #ffffff 0%,#e0e0e0 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
		filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#e0e0e0',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
		width:100%;
		height:100%;
	}

	.login-container {
		max-width:380px;
		margin:0 auto;
		background:#fff;

		@media screen and (max-width: $mobile) {
			margin:64px 15px;
			width:calc(100% - 30px);
			min-height:auto;
		}

		h3 {
			color:$lightBlue;
			font-weight: bold;

			small {
				display:block;
				font-size:18px;
			}
		}

		.first-access {
			nav {
				.nav-link {
					color: $lightBlue;
					
					border-bottom: 2px solid $grey;
					&.router-link-exact-active   {
						border-bottom-color: $lightBlue;
					}
				}
			}
		}

	}

</style>



// WEBPACK FOOTER //
// src/pages/login/loginPage.vue